"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.Logger = exports.LogLevel = void 0;const levels = ['debug', 'info', 'warn', 'error'];

const noop = function () {}; // eslint-disable-line
let logLevel, logger;let

LogLevel = /*#__PURE__*/function (LogLevel) {LogLevel["debug"] = "debug";LogLevel["info"] = "info";LogLevel["warn"] = "warn";LogLevel["error"] = "error";return LogLevel;}({});exports.LogLevel = LogLevel;






class Logger {

  static get instance() {
    if (!logger) {
      Logger.setLogLevel(LogLevel.info); //default if not set
    }
    return logger;
  }

  static get prefix() {
    return "SSO Client:";
  }

  static format(message) {
    return `${Logger.prefix} ${message}`;
  }

  static reset() {
    logger = undefined;
    logLevel = undefined;
  }

  static setLogLevel(level) {
    /* istanbul ignore next */
    if (logger && logLevel === level) {
      return;
    }
    logger = {};
    logLevel = level;
    const shouldLog = function (lvl) {
      return levels.indexOf(lvl) >= levels.indexOf(level);
    };

    levels.forEach(function (lvl) {
      logger[lvl] = shouldLog(lvl) ? log : noop;

      function log() {
        arguments[0] = Logger.format(arguments[0]); // eslint-disable-line
        console[lvl](...arguments); // eslint-disable-line
      }
    });
  }

  static debug(...data) {return Logger.instance.debug(...data);}
  static info(...data) {return Logger.instance.info(...data);}
  static log(...data) {return Logger.instance.info(...data);}
  static warn(...data) {return Logger.instance.warn(...data);}
  static error(...data) {return Logger.instance.error(...data);}
}exports.Logger = Logger;